import { render, staticRenderFns } from "./Region.vue?vue&type=template&id=3b7ef672&scoped=true"
import script from "./Region.vue?vue&type=script&lang=js"
export * from "./Region.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7ef672",
  null
  
)

export default component.exports